<!--
  Template-Mode page header (Kontoauszug title).
  MUST stay at top level, outside any guard, so @ViewChild('headerTemplate') resolves.
  Conditional content is guarded INSIDE the template.
-->
<ng-template #headerTemplate>
    @if (objectIdentifier) {
        <div class="flex justify-content-between w-full align-items-center surface-0 px-4 py-3">
            <div class="flex align-items-center gap-3">
                <i class="fa-light fa-file-invoice-dollar fa-2x"></i>
                <div>
                    <h5 class="mb-0">Kontoauszug</h5>
                </div>
            </div>
        </div>
    }
</ng-template>

<!-- Page body: hosts the CommissionStatement object component once the identifier is resolved. -->
@if (objectIdentifier) {
    <mvs-cn-commission-statement-object-component
            [objectIdentifier]="objectIdentifier">
    </mvs-cn-commission-statement-object-component>
}
